var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.food
    ? _c(
        "div",
        [
          _vm.$store.getters["session/userHasCompanies"]
            ? _c(
                "base-dialog",
                {
                  attrs: {
                    dontShowAgainCookie: _vm.COOKIE_FOOD_DETAILS_DIALOG,
                    dontShowAgainCookieExpirationDays: 30
                  },
                  model: {
                    value: _vm.showFoodDetailsDialog,
                    callback: function($$v) {
                      _vm.showFoodDetailsDialog = $$v
                    },
                    expression: "showFoodDetailsDialog"
                  }
                },
                [
                  _c("p", [
                    _vm._v(
                      _vm._s(_vm.$t("patient.foods.food-detail-dialog-info"))
                    )
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "BModal",
            {
              attrs: {
                title: _vm.modalTitle,
                "hide-header": "",
                "hide-footer": "",
                centered: ""
              },
              model: {
                value: _vm.addPatientFoodModalVisible,
                callback: function($$v) {
                  _vm.addPatientFoodModalVisible = $$v
                },
                expression: "addPatientFoodModalVisible"
              }
            },
            [
              _c(
                "div",
                { staticClass: "text-center" },
                [
                  !_vm.foodIsInPatientFoods
                    ? _c(
                        "base-checkbox",
                        {
                          model: {
                            value: _vm.newPatientFood.inDiet,
                            callback: function($$v) {
                              _vm.$set(_vm.newPatientFood, "inDiet", $$v)
                            },
                            expression: "newPatientFood.inDiet"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("patient.foods.diet-question")))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.habitCreationVisible
                    ? _c(
                        "div",
                        [
                          !_vm.foodIsInPatientFoods
                            ? _c(
                                "base-checkbox",
                                {
                                  model: {
                                    value: _vm.newPatientFood.createHabit,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.newPatientFood,
                                        "createHabit",
                                        $$v
                                      )
                                    },
                                    expression: "newPatientFood.createHabit"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("patient.foods.habits-question")
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.newPatientFood &&
                          _vm.newPatientFood.createHabit &&
                          !_vm.newPatientFood.habitId
                            ? _c(
                                "div",
                                [
                                  _c("healthy-habits-form", {
                                    attrs: {
                                      inModal: "",
                                      habitDescription: _vm.$i18nHelpers.normalize(
                                        _vm.food.name
                                      )
                                    },
                                    on: {
                                      habitCreated: function(habitId) {
                                        return _vm.onNewHabitCreated(habitId)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.newPatientFood.habitId
                    ? _c(
                        "div",
                        [
                          _c(
                            "b-alert",
                            { attrs: { show: "", variant: "success" } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("patient.foods.habit-created-success")
                                )
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.foodIsInPatientFoods
                    ? _c(
                        "b-button",
                        {
                          staticClass: "mt-4",
                          attrs: { variant: "primary" },
                          on: { click: _vm.addPatientFood }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("patient.foods.add-to-my-foods"))
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "BModal",
            {
              attrs: { "hide-header": "", "hide-footer": "", centered: "" },
              model: {
                value: _vm.deletePatientFoodModalVisible,
                callback: function($$v) {
                  _vm.deletePatientFoodModalVisible = $$v
                },
                expression: "deletePatientFoodModalVisible"
              }
            },
            [
              _c(
                "div",
                { staticClass: "text-center" },
                [
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("patient.foods.remove-from-my-foods-warning")
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _vm.foodHasCreatedHabit
                    ? _c(
                        "base-checkbox",
                        {
                          model: {
                            value: _vm.deleteAlsoFromHabits,
                            callback: function($$v) {
                              _vm.deleteAlsoFromHabits = $$v
                            },
                            expression: "deleteAlsoFromHabits"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("patient.foods.remove-from-habits"))
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "danger" },
                      on: { click: _vm.deleteFoodFromPatientFoods }
                    },
                    [_vm._v(_vm._s(_vm.$t("patient.foods.delete-food")))]
                  ),
                  _vm._v(" "),
                  _vm.patientFood.inDiet
                    ? _c(
                        "b-button",
                        {
                          attrs: { variant: "info" },
                          on: { click: _vm.removeFoodFromDiet }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("patient.foods.remove-from-diet"))
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "1" } },
                [
                  _c("b-icon-chevron-left", {
                    staticClass: "chevron-icons",
                    attrs: { size: "2rem" },
                    on: {
                      click: function($event) {
                        return _vm.goToSlide(-1)
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "10" } },
                [
                  _c(
                    "b-row",
                    {
                      staticClass:
                        "neu-card-food text-center w-100 position-relative",
                      attrs: { cols: "12", "cols-xl": "12" }
                    },
                    [
                      _c("h3", { staticClass: "m-auto d-block w-100" }, [
                        _vm._v(
                          _vm._s(_vm.$i18nHelpers.normalize(_vm.food.name))
                        )
                      ]),
                      _vm._v(" "),
                      _vm.$store.getters["session/userHasCompanies"] &&
                      _vm.foodIsInPatientFoods
                        ? _c(_vm.bellIconComponentType, {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover",
                                value: _vm.createHabitTooltip,
                                expression: "createHabitTooltip",
                                modifiers: { hover: true }
                              }
                            ],
                            tag: "component",
                            staticClass: "position-absolute bell-food",
                            attrs: { variant: "primary" },
                            on: { click: _vm.onBellIconClick }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.$store.getters["session/userHasCompanies"]
                        ? _c(_vm.heartIconComponentType, {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover",
                                value: _vm.addToFavoritesTooltip,
                                expression: "addToFavoritesTooltip",
                                modifiers: { hover: true }
                              }
                            ],
                            tag: "component",
                            staticClass: "position-absolute heart-food",
                            attrs: { variant: "primary" },
                            on: { click: _vm.onHeartIconClick }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("ImagesTransition", {
                        staticClass: "mt-5",
                        attrs: { images: _vm.food.images }
                      }),
                      _vm._v(" "),
                      _c("h5", { staticClass: "mt-5" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$i18nHelpers.normalize(
                              _vm.getCurrentFoodDescription
                            )
                          )
                        )
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "pt-3" },
                    [
                      _vm.$store.getters["session/userHasCompanies"]
                        ? _c("ArrowButton", {
                            staticClass: "ml-auto",
                            attrs: {
                              variant: "primary",
                              action: function() {
                                _vm.$router.push({ name: "FavoritesFood" })
                              },
                              text: _vm.$t("patient.foods.go-to-my-foods")
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "1" } },
                [
                  _c("b-icon-chevron-right", {
                    staticClass: "chevron-icons",
                    attrs: { size: "5rem" },
                    on: {
                      click: function($event) {
                        return _vm.goToSlide(1)
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0db10fd5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0db10fd5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/webapp/patient/foods/FoodDetail.vue
// module id = 4066
// module chunks = 73